<div class="container-fluid mt-4">
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header align-items-center d-flex justify-content-between gap-2">
        <h5 class="font-medium election-title">🗂️ Assigned Audited Societies</h5>
        <!-- <button type="button" class="btn btn-info btn-sm" (click)="openNewTab('audit/addmember')">
          Add Member
        </button> -->

      </div>
<div class="card-body">
          <div class="row align-items-end">

            <!-- Society -->
            <div class="col-lg-4 col-md-6 mb-2">
              <label for="societyDetailId" class="form-label">Society</label>
              <select class="form-control" [(ngModel)]="filter.societyDetailId" name="societyDetailId"
                id="societyDetailId">
                <option value="0">Select Society</option>
                <option *ngFor="let data of societyFilter" [value]="data.id">{{ data.name }}</option>
              </select>
            </div>

            <!-- Society Type -->
            <div class="col-lg-4 col-md-6 mb-2">
              <label for="societyTypeId" class="form-label">Society Type</label>
              <select class="form-control" [(ngModel)]="filter.societyTypeId" name="societyTypeId" id="societyTypeId"
                (change)="searchDataByFilters()">
                <option value="0" disabled>Select Society Type</option>
                <option *ngFor="let data of societyTypeFilter" [value]="data.id">{{ data.name }}</option>
              </select>
            </div>

            <!-- District -->
            <div class="col-lg-4 col-md-4 mb-2">
              <label for="districtId" class="form-label">District</label>
              <select class="form-control" [(ngModel)]="filter.districtId" id="districtId" name="districtId"
                (change)="onDistrictChange($event); searchDataByFilters()">
                <option value="0" disabled selected>Select District</option>
                <option *ngFor="let dist of districts" [value]="dist.id">{{ dist.name }}</option>
              </select>
            </div>

            <!-- Circle -->
            <div class="col-lg-4 col-md-4 mb-2">
              <label for="circle" class="form-label">Circle</label>
              <select class="form-control" [(ngModel)]="filter.circleId" id="circle" name="circle"
                (change)="onCircleChange($event); searchDataByFilters()">
                <option value="0" disabled selected>Select Circle</option>
                <option *ngFor="let circle of circlesData" [value]="circle.id">{{ circle.name }}</option>
              </select>
            </div>

            <!-- Block (Visible Based on Condition) -->
            <div class="col-lg-4 col-md-4 mb-2" *ngIf="isBlockVisible">
              <label for="block" class="form-label">Block</label>
              <select class="form-control" [(ngModel)]="filter.blockId" id="block" name="block"
                (change)="searchDataByFilters()">
                <option value="0" disabled selected>Select Block</option>
                <option *ngFor="let block of blocksData" [value]="block.id">{{ block.name }}</option>
              </select>
            </div>

            <!-- Audit Status -->
            <!-- <div class="col-lg-4 col-md-6 mb-2">
                <label for="ddlStatus" class="form-label">Audit Status</label>
                <select class="form-control" [(ngModel)]="filter.isStatus"  name="isStatus" id="isStatus" (change)="searchDataByFilters()">
                  <option value="" disabled>Select Audit Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Complete">Complete</option>
                </select>
              </div> -->

            <!-- Search Button -->
            <div class="col-lg-12 col-md-6 mb-2 text-end">
              <button type="button" class="btn btn-primary" (click)="searchDataByFilters()">Search</button>
            </div>

          </div>
        </div>
    </div>
  </div>
<div class="col-lg-12">
   <div class="pagination-controls"
              style="display: flex; justify-content: flex-end; align-items: center; width: 100%;">
              <div class="pagination-right" style="display: flex; align-items: center;">
                <label for="rowsPerPage" style="margin-right: 8px;">Display Data:</label>
                <select id="rowsPerPage" [(ngModel)]="page.pageSize" (change)="onRowsPerPageChange()"
                  style="padding: 5px; font-size: 14px;">

                  <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{size}}</option>
                </select>
              </div>
            </div>
            <br />
      <div class="card">
        <div class="card-body">
          <div class=" mb-2">
            <div class="d-flex justify-content-end mb-2">
              <!-- <input type="text" [(ngModel)]="searchText" (input)="filterSocietyTable()" class="form-control w-25"
          placeholder="Search Society..." /> -->
            </div>

               <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
              [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
              [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
              (page)="setPage($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
              [loadingIndicator]="loading">

              <!-- Serial Number Column -->
              <ngx-datatable-column name="#" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                 <span>
                  {{ (page.pageNumber * page.pageSize) + rowIndex + 1 }}
                  </span>
                </ng-template>
              </ngx-datatable-column>

              <!-- Dynamic Data Columns -->
              <ngx-datatable-column *ngFor="let column of columns" [name]="column.name" [prop]="column.prop"
                [sortable]="true">
                <ng-template ngx-datatable-cell-template let-value="value">
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Action Column -->
              <ngx-datatable-column name="Action" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center gap-2">
                    <a class="edit btn btn-info btn-sm"
                      [style.display]="(statusid == 4 || statusid == 8 || statusid == 5 )  &&  row.verifierName == null || (statusid == 0 && row.iRoleID == 13  && !row.isCheckListCompleted ) || (statusid == 9 && row.iRoleID == 13  && !row.isCheckListCompleted ) ? 'none' : 'inline-block'"
                      (click)="processToViewChecklist(row.isocietydetailsid, row.iSocietyDetailsTranID)">
                      <i class="bi bi-eye"></i>
                    </a>
                    <a class="edit btn btn-info btn-sm" href="javascript:void(0);"
                      [style.display]="statusid == 0 && row.iRoleID == 13 && !row.isCheckListCompleted ? 'none' : (statusid == 0 ? 'inline-block' : 'none')"
                      (click)="processToVerifier(row.isocietydetailsid, row.iSocietyDetailsTranID)">
                      <i class="bi bi-pencil-square"></i>
                    </a>

                    <!-- <a href="javascript:void(0)" title="Payment" class="btn btn-primary btn-sm"
                    [style.display]="!row.ispayment ? 'none' : 'inline-block'">
                    Payment Request
                  </a> -->

                    <a href="javascript:void(0)" (click)="selectedRow = row; actionTaken = false"
                      title="View Auditor Remark" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                      [style.display]="statusid == 4 && !actionTaken?  'inline-block' : 'none'"
                      data-bs-target="#ChecklistRemark">
                      <i class="bi bi-chat-left-text"></i>
                    </a>


                    <!-- <a href="javascript:void(0)" (click)="selectedRow = row" title="View Auditor Remark"
                      class="btn btn-warning btn-sm" [style.display]="statusid == 7 ?  'inline-block' : 'none'"
                      data-bs-toggle="modal" data-bs-target="#ChecklistStatusReport">
                      <i class="bi bi-chat-left-text"></i>
                    </a> -->



                    <span *ngIf="(statusid == 8) && !row.isCheckListCompleted "
                      class="text-success fw-bold d-inline-block">
                      Departmental Auditor Allotment Done
                    </span>
                    <span *ngIf="statusid == 5 && row.iRoleID == 13 && row.verifierName == null"
                      class="text-success fw-bold d-inline-block">
                      Application Reject from AR side
                    </span>


<!-- 
                    <a type="button" class="btn btn-success btn-sm" title="Allot Auditor"
                      [style.display]="acceptedRows[row.isocietydetailsid] ||  (statusid == 0 && row.iRoleID == 13 && !row.isCheckListCompleted) ||  actionTaken ? 'inline-block' : 'none'"
                      (click)="openAllotAuditor(row.isocietydetailsid, row.iAllotAuditorID, row.ssocietyname)">
                      <i class="fa fa-user"></i>
                    </a> -->
                     <a type="button" class="btn btn-success btn-sm" title="Allot Auditor"
                      [style.display]="actionTaken  || acceptedRows[row.isocietydetailsid] || (statusid == 0 || statusid == 9 )  && row.iRoleID == 13  && !row.isCheckListCompleted ?  'inline-block' : 'none'"
                      (click)="openAllotAuditor(row.isocietydetailsid,row.iAllotAuditorID,row.ssocietyname)">
                      <i class="fa fa-user"></i>
                    </a>





                  </div>
                </ng-template>
              </ngx-datatable-column>


            </ngx-datatable>

            <div class="modal fade" id="ChecklistRemark" data-bs-backdrop="static" data-bs-keyboard="false"
              tabindex="-1" aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content">

                  <!-- Modal Header -->
                  <div class="modal-header">
                    <h5 class="modal-title"><strong>Rejection Remark</strong></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="cancelRejectRemark()"
                      aria-label="Close"></button>
                  </div>

                  <!-- Modal Body -->
                  <div class="modal-body">
                    <!-- Role Selection -->
                    <div class="col-lg-4 col-md-6 mb-3">
                      <label class="form-label">Select Role</label>
                      <select class="form-control" name="selectedViewRole" [(ngModel)]="selectedViewRole" required>
                        <option value="0" selected>Select Roles</option>
                        <option value="1">Auditor</option>
                        <option value="2" *ngIf="showRejectRemarkInput">AR</option>
                      </select>
                    </div>

                    <!-- Auditor Remark -->
                    <div class="col-lg-12 mb-3" *ngIf="selectedViewRole == 1 && !showRejectRemarkInput">
                      <label class="form-label">Auditor Remark</label>
                      <textarea class="form-control" rows="5" placeholder="No remarks available" [(ngModel)]="hrremark"
                        disabled></textarea>
                    </div>

                    <!-- AR Rejection Remark Input -->
                    <div class="col-lg-12" *ngIf="(selectedViewRole === 2 || showRejectRemarkInput)">
                      <label class="form-label">AR Rejection Remark</label>

                      <textarea class="form-control mb-3" rows="3" placeholder="Enter AR Rejection Remark"
                        [(ngModel)]="arRejectionRemark" [disabled]="selectedRow?.arRejectionRemark">
  </textarea>

                      <div class="d-flex justify-content-end" *ngIf="showRejectRemarkInput ">
                        <button type="button" class="btn btn-success me-2"
                          (click)="submitArRejectionRemark(selectedRow?.iSocietyDetailsTranID,selectedRow?.iAllotAuditorID )">
                          Add Remark
                        </button>

                      </div>
                    </div>


                  </div>

                  <!-- Modal Footer with Reject/Accept (visible only before showing rejection input) -->
                  <div class="modal-footer"
                    *ngIf="!selectedRow?.isMoveForward && !showRejectRemarkInput && statusid == 4">
                    <button type="button" class="btn btn-danger" (click)="onRejectClicked()">
                      <i class="fa fa-times me-1"></i> Reject
                    </button>
                    <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                      (click)="markAccepted(selectedRow?.isocietydetailsid)">
                      <i class="fa fa-check me-1"></i> Accept
                    </button>
                  </div>

                </div>
              </div>
            </div>

            <div class="modal fade" id="ChecklistStatusReport" data-bs-backdrop="static" data-bs-keyboard="false"
              tabindex="-1" aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content">

                  <!-- Modal Header -->
                  <div class="modal-header">
                    <h5 class="modal-title"><strong>SendBack Remark</strong></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="cancelRejectRemark()"
                      aria-label="Close"></button>
                  </div>

                  <!-- Modal Body -->
                  <div class="modal-body">
                    <!-- Role Selection -->
                    <div class="col-lg-4 col-md-6 mb-3">
                      <label class="form-label">Select Role</label>
                      <select class="form-control" name="selectedRole" [(ngModel)]="selectedRole" required>
                        <option value="0" disabled selected>Select Roles</option>
                        <option value="1">Verifier Remark</option>
                        <option value="2">AR Remark</option>
                      </select>
                    </div>

                    <!-- Scrutiny Remark -->
                    <div class="col-lg-12 mb-3" *ngIf="selectedRole == 1">
                      <label class="form-label">Scrutiny Remark</label>
                      <textarea class="form-control" rows="5" placeholder="No remarks available" [(ngModel)]="hrremark"
                        disabled></textarea>
                    </div>

                    <!-- AR Rejection Remark Input -->
                    <div class="col-lg-12" *ngIf="showRejectRemarkInput || selectedRole == 2">
                      <label class="form-label">AR Remark</label>

                      <textarea class="form-control mb-3" rows="3" placeholder="Enter AR sendback Remark"
                        [(ngModel)]="remark" [disabled]="isArRemarkReadonly">
  </textarea>
                      <div class="col-lg-4 col-md-6 mb-2" *ngIf="selectedRole == 2 || selectedRole == 3">
                        <label class="form-label">Select Status<span class="text-danger">*</span></label>
                        <select class="form-control" [(ngModel)]="ddlStatus" name="ddlStatus" required>
                          <option value="" disabled>Select Status</option>
                          <option value="MoveForwardAudit" *ngIf="roleid === 13 && statusid == 7">Move Forward
                          </option>

                          <option value="SendBackAudit"
                            *ngIf="(roleid === 13 && statusid == 5) || (roleid === 13 && statusid == 7 && selectedRow?.isSendBack)">
                            Send Back</option>
                        </select>
                      </div>
                      <div class="d-flex justify-content-end" *ngIf="!isArRemarkReadonly">
                        <button type="button" class="btn btn-success me-2"
                          (click)="submitArSendBackRemark(selectedRow?.iSocietyDetailsTranID,selectedRow.iAllotAuditorID)">
                          Add Remark
                        </button>

                      </div>
                    </div>


                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>



    </div>
</div>
</div>